module.exports = __webpack_public_path__ + "img/issuenthemeschedule.3002aa1.jpg";